import Project from '../ProjectList/Project'
/* for now, reuse the ProjectList Project */
export default Project
